import React from 'react';
import throttle from 'lodash/throttle';

export interface Props {
  id?: string;
  tabIndex?: -1 | undefined;
  width?: number;
  widthBreakpoints: number[];
  className?: string;
  onSettled?: () => void;
  forwardedRef?: React.ForwardedRef<HTMLDivElement>;
}

const THROTTLE_TIMEOUT = 100;

export default class ElementQueries extends React.Component<
  React.PropsWithChildren<Props>
> {
  private rootRef: HTMLDivElement;

  componentDidMount() {
    this.setBreakpoints();

    window.addEventListener('resize', this.setBreakpoints);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setBreakpoints);
  }

  render() {
    const { id, children, width, className, tabIndex } = this.props;
    return (
      <div
        id={id}
        tabIndex={tabIndex}
        ref={this.saveRootRef}
        data-min-width={width && this.getMinWidthAttrValue(width)}
        data-max-width={width && this.getMaxWidthAttrValue(width)}
        className={className}
      >
        {children}
      </div>
    );
  }

  saveRootRef = node => {
    this.rootRef = node;

    const { forwardedRef } = this.props;
    if (forwardedRef) {
      if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      } else {
        forwardedRef.current = node;
      }
    }
  };

  getMinWidthAttrValue = elementWidth => {
    const minWidth = this.props.widthBreakpoints.filter(
      width => width <= elementWidth
    );
    return minWidth.join(' ');
  };

  getMaxWidthAttrValue = elementWidth => {
    const maxWidth = this.props.widthBreakpoints.filter(
      width => width >= elementWidth
    );
    return maxWidth.join(' ');
  };

  setBreakpoints = throttle(
    () =>
      requestAnimationFrame(() => {
        if (!this.rootRef) {
          return;
        }

        const sizes = this.rootRef.getBoundingClientRect();

        this.rootRef.setAttribute(
          'data-max-width',
          this.getMaxWidthAttrValue(sizes.width)
        );
        this.rootRef.setAttribute(
          'data-min-width',
          this.getMinWidthAttrValue(sizes.width)
        );
        this.props.onSettled && this.props.onSettled();
      }),
    THROTTLE_TIMEOUT
  );
}
